export default "__VITE_ASSET__tz7yjMzO__"